import skillsData from 'data/skillsData';
import React from 'react';
import { Container, Row } from 'react-bootstrap';
import '../styles/Skills.css';
import Skill from './Skill';

export default function Skills() {
    return (
        <Container fluid='lg'>
            <section id='skills' className='skills'>
                <h1 className='text-center mb-5'>My Skills</h1>
                <Row>
                    {
                        skillsData.map(data => <Skill key={data.id} name={data.name} percentage={data.percentage} image={data.image} />)
                    }
                </Row>
            </section>
        </Container>
    );
};